/* Kermit — visionneuse d'images produit au clic (remplace le zoom-dialog d'Horizon). */
(function () {
  if (window.__kermitZoom) return; window.__kermitZoom = true;
  var css = "\
.kz{position:fixed;inset:0;width:100vw;height:100vh;height:100dvh;margin:0;z-index:2147483000;background:#fff;display:none;grid-template-rows:minmax(0,1fr) auto;grid-template-columns:100%;color:#1f1f21;touch-action:none;opacity:0;transition:opacity .2s ease;box-sizing:border-box}\
.kz.is-open{display:grid}.kz:focus{outline:none}.kz.is-visible{opacity:1}\
.kz__stage{position:relative;grid-row:1;min-height:0;min-width:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:zoom-in;touch-action:none;padding:16px;box-sizing:border-box}\
.kz__stage.is-zoomed{cursor:grab}.kz__stage.is-drag{cursor:grabbing}\
.kz__img{display:block;flex:0 0 auto;position:static;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;margin:0;padding:0;border:0;opacity:0;user-select:none;-webkit-user-drag:none;transform-origin:center center;transition:transform .2s ease,opacity .15s ease;will-change:transform}.kz__img.is-ready{opacity:1}\
.kz__stage.is-drag .kz__img{transition:none}\
.kz__btn{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;border:2px solid #1f1f21;background:#fff;color:#1f1f21;cursor:pointer;padding:0;box-shadow:0 2px 8px rgba(0,0,0,.12)}\
.kz__btn:hover,.kz__btn:focus-visible{border-color:#0070bd;color:#0070bd;outline:none}\
.kz__btn svg{width:22px;height:22px}\
.kz__close{top:16px;right:16px}\
.kz__prev{left:16px;top:50%;transform:translateY(-50%)}.kz__next{right:16px;top:50%;transform:translateY(-50%)}\
.kz__thumbs{grid-row:2;min-width:0;box-sizing:border-box;display:flex;gap:8px;justify-content:center;overflow-x:auto;padding:12px 16px calc(12px + env(safe-area-inset-bottom));border-top:1px solid #e6e6e6;background:#fff}\
.kz__thumb{flex:0 0 auto;width:64px;height:64px;padding:0;border:2px solid transparent;border-radius:6px;background:#f5f5f5;cursor:pointer;overflow:hidden}\
.kz__thumb img{width:100%;height:100%;object-fit:contain;display:block}\
.kz__thumb[aria-current=true]{border-color:#f7931e}.kz__thumb:focus-visible{outline:2px solid #0070bd;outline-offset:2px}\
.kz--single .kz__prev,.kz--single .kz__next,.kz--single .kz__thumbs{display:none}\
@media (max-width:749px){.kz__prev,.kz__next{display:none}.kz__btn{width:42px;height:42px}.kz__thumb{width:52px;height:52px}.kz__stage{padding:8px}}\
html.kz-lock,html.kz-lock body{overflow:hidden}\
media-gallery .product-media-container--zoomable,media-gallery .product-media-container__zoom-button{cursor:pointer}";
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var I = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    l: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    r: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>'
  };
  var root, stage, img, thumbs, items = [], idx = 0, scale = 1, tx = 0, ty = 0, lastFocus = null;

  function build() {
    root = document.createElement('div');
    root.className = 'kz'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Visionneuse d\u2019images'); root.setAttribute('tabindex', '-1');
    root.innerHTML = '<div class="kz__stage"><img class="kz__img" alt="" draggable="false"></div>' +
      '<button type="button" class="kz__btn kz__close" aria-label="Fermer">' + I.x + '</button>' +
      '<button type="button" class="kz__btn kz__prev" aria-label="Image pr\u00e9c\u00e9dente">' + I.l + '</button>' +
      '<button type="button" class="kz__btn kz__next" aria-label="Image suivante">' + I.r + '</button>' +
      '<div class="kz__thumbs" role="group" aria-label="Miniatures"></div>';
    document.body.appendChild(root);
    stage = root.querySelector('.kz__stage'); img = root.querySelector('.kz__img'); thumbs = root.querySelector('.kz__thumbs');
    root.querySelector('.kz__close').addEventListener('click', close);
    root.querySelector('.kz__prev').addEventListener('click', function () { go(idx - 1); });
    root.querySelector('.kz__next').addEventListener('click', function () { go(idx + 1); });
    document.addEventListener('keydown', onKey, true);
    bindPointer();
  }
  function bestSrc(el) {
    var ss = el.getAttribute('srcset') || el.getAttribute('data-srcset') || '';
    var best = el.currentSrc || el.src, bw = 0;
    ss.split(',').forEach(function (p) { var a = p.trim().split(/\s+/); var w = parseInt(a[1]) || 0; if (a[0] && w > bw) { bw = w; best = a[0]; } });
    return best;
  }
  function apply() {
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    stage.classList.toggle('is-zoomed', scale > 1);
  }
  function reset() { scale = 1; tx = 0; ty = 0; if (stage) stage.classList.remove('is-drag'); apply(); }
  function isOpen() { return !!root && root.classList.contains('is-open'); }
  function keepFocus() { if (isOpen() && !root.contains(document.activeElement)) root.focus({ preventScroll: true }); }
  function clamp() {
    var r = stage.getBoundingClientRect(), w = img.offsetWidth * scale, h = img.offsetHeight * scale;
    var mx = Math.max(0, (w - r.width) / 2), my = Math.max(0, (h - r.height) / 2);
    tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
  }
  function zoomAt(cx, cy) {
    if (scale > 1) { reset(); return; }
    var r = img.getBoundingClientRect(); scale = 2.5;
    var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    tx = -ox * (scale - 1); ty = -oy * (scale - 1); clamp(); apply();
  }
  function go(i) {
    var n = items.length; if (!n) return;
    idx = (i + n) % n; reset();
    img.classList.remove('is-ready'); img.onload = function () { reset(); img.classList.add('is-ready'); }; img.src = items[idx].src; img.alt = items[idx].alt || ''; if (img.complete && img.naturalWidth) img.onload();
    Array.prototype.forEach.call(thumbs.children, function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); if (k === idx) t.scrollIntoView({ block: 'nearest', inline: 'center' }); });
  }
  function open(list, i) {
    if (!root) build();
    items = list; thumbs.innerHTML = '';
    root.classList.toggle('kz--single', list.length < 2);
    list.forEach(function (it, k) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'kz__thumb';
      b.setAttribute('aria-label', 'Image ' + (k + 1) + ' sur ' + list.length);
      b.innerHTML = '<img src="' + it.thumb + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { go(k); }); thumbs.appendChild(b);
    });
    lastFocus = document.activeElement;
    document.documentElement.classList.add('kz-lock');
    root.classList.add('is-open'); go(i); requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-visible'); }); });
    root.querySelector('.kz__close').focus({ preventScroll: true });
  }
  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open', 'is-visible'); document.documentElement.classList.remove('kz-lock'); reset();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onKey(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (scale > 1) reset(); else close(); keepFocus(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopPropagation(); go(idx - 1); keepFocus(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); e.stopPropagation(); go(idx + 1); keepFocus(); }
    else if (e.key === 'Tab') {
      var f = root.querySelectorAll('button:not([disabled])'), vis = Array.prototype.filter.call(f, function (b) { return b.offsetParent !== null; });
      if (!vis.length) return; if (!root.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? vis[vis.length - 1] : vis[0]).focus(); return; } var a = vis[0], z = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  }
  function bindPointer() {
    var pts = {}, sx, sy, stx, sty, moved = false, lastTap = 0, t0 = 0, pinch0 = 0, scale0 = 1;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.kz__btn')) return;
      pts[e.pointerId] = e; stage.setPointerCapture(e.pointerId);
      sx = e.clientX; sy = e.clientY; stx = tx; sty = ty; moved = false; t0 = Date.now();
      var k = Object.keys(pts); if (k.length === 2) { var a = pts[k[0]], b = pts[k[1]]; pinch0 = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); scale0 = scale; }
      stage.classList.add('is-drag');
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return; pts[e.pointerId] = e;
      var k = Object.keys(pts);
      if (k.length === 2 && pinch0) {
        var a = pts[k[0]], b = pts[k[1]], d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        scale = Math.min(4, Math.max(1, scale0 * d / pinch0)); if (scale === 1) { tx = ty = 0; } clamp(); apply(); moved = true; return;
      }
      var dx = e.clientX - sx, dy = e.clientY - sy; if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
      if (scale > 1) { tx = stx + dx; ty = sty + dy; clamp(); apply(); }
    });
    stage.addEventListener('lostpointercapture', function (e) { if (pts[e.pointerId]) { delete pts[e.pointerId]; if (!Object.keys(pts).length) { pinch0 = 0; stage.classList.remove('is-drag'); } } });
    function up(e) {
      if (!pts[e.pointerId]) return; delete pts[e.pointerId];
      try { stage.releasePointerCapture(e.pointerId); } catch (_) {}
      if (Object.keys(pts).length) return; pinch0 = 0; stage.classList.remove('is-drag'); keepFocus();
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (scale === 1 && moved && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && Date.now() - t0 < 800) { go(idx + (dx < 0 ? 1 : -1)); return; }
      if (moved || e.type === 'pointercancel') return;
      if (e.pointerType === 'touch') {
        var now = Date.now(); if (now - lastTap < 300) { lastTap = 0; zoomAt(e.clientX, e.clientY); } else lastTap = now;
      } else { var ir = img.getBoundingClientRect(); var onImg = e.clientX >= ir.left && e.clientX <= ir.right && e.clientY >= ir.top && e.clientY <= ir.bottom; if (onImg || scale > 1) zoomAt(e.clientX, e.clientY); else close(); keepFocus(); }
    }
    stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
    window.addEventListener('resize', function () { if (root.classList.contains('is-open')) reset(); });
  }
  function collect(gallery, clickedContainer) {
    var sel = '.product-media-container--image';
    var all = Array.prototype.filter.call(gallery.querySelectorAll(sel), function (c) { return !c.closest('zoom-dialog, dialog'); });
    var grid = clickedContainer.closest('.media-gallery__grid');
    var group = all.filter(function (c) { return grid ? c.closest('.media-gallery__grid') === grid : !c.closest('.media-gallery__grid'); });
    var list = [], start = 0, seen = {};
    group.forEach(function (c) {
      var im = c.querySelector('img'); if (!im) return;
      var src = bestSrc(im), key = src.split('?')[0].replace(/_\d+x\d*(?=\.)/, '');
      if (seen[key]) { if (c === clickedContainer) start = seen[key] - 1; return; }
      list.push({ src: src, thumb: im.currentSrc || im.src, alt: im.alt }); seen[key] = list.length;
      if (c === clickedContainer) start = list.length - 1;
    });
    return { list: list, start: start };
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!(t instanceof Element)) return;
    var gallery = t.closest('media-gallery'); if (!gallery || t.closest('zoom-dialog, dialog, .slideshow-controls, slideshow-arrows, .slideshow-control, a[href]')) return;
    var c = t.closest('.product-media-container--image'); if (!c || !c.querySelector('img')) return;
    var r = collect(gallery, c); if (!r.list.length) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    open(r.list, r.start);
  }, true);
})();
